import React from 'react'
import MenuIcon from '@material-ui/icons/Menu'
import useScrollTrigger from '@material-ui/core/useScrollTrigger'
import PropTypes from 'prop-types'
import {
  Link as RouterLink
} from 'react-router-dom'
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  makeStyles,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import Strings from '../../whitelist/strings'
import amnLogo from '../../images/logo-amn.png'

function ElevationScroll (props) {
  const { children, window } = props
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined
  })

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0
  })
}

ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func
}

const useStyles = makeStyles((theme) => ({
  title: {
    height: '105px'
  },
  logo: {
    width: '110px',
    height: '37px'
  }
}))

export function NavigationBar (props) {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    // <ElevationScroll {...props}>
    <AppBar position={matches ? '' : 'fixed'} elevation={1}>
      <Toolbar className={classes.title}>
        <img src={amnLogo} alt='Logo' className={classes.logo} />
      </Toolbar>
    </AppBar>
    // </ElevationScroll>
  )
}
